import { FC } from "react"
import { Gear } from "./Gear"
import style from "./RepairIllustration.module.css"

type RepairIllustrationProps = {
  isRepairing: boolean
}

export const RepairIllustration: FC<RepairIllustrationProps> = ({ isRepairing }) => {
  return (
    <div
      className={style.illustration}
      aria-hidden={"true"}
    >
      <img
        src={"/illustration/computer-kamae-logo-bi-excla.png"}
        alt={""}
        className={style.computer}
      />
      <span className={style.gear}>
        <Gear isSpinning={isRepairing} />
      </span>
      <img
        src={"/illustration/no-result.png"}
        alt={""}
        className={style["broken-file"]}
      />
    </div>
  )
}
